
import CategoryHubFinder from '@/components/CategoryHubFinder.vue'
import CategoryHubTile from '@/components/CategoryHubTile.vue'
import CollectionPageStructuredData from '@/components/CollectionPageStructuredData.vue'
import categoryMixin from '@/mixins/categoryMixin'

export default {
  name: 'CategoryHub',
  components: {
    CategoryHubFinder,
    CategoryHubTile,
    CollectionPageStructuredData,
  },
  mixins: [categoryMixin],
  props: {
    category: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      default: 'B',
    },
    adminUrl: {
      type: String,
      default: null,
    },
    isPaginated: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    popularSockets() {
      return this.category.popular_sockets?.items || []
    },
    holdsBulbs() {
      if (typeof this.category.plate_search === 'boolean') {
        return this.category.plate_search
      }
      return this.category.holds_bulbs !== false
    },
    finderInHead() {
      return (
        this.holdsBulbs &&
        this.variant !== 'C' &&
        this.popularSockets.length > 0
      )
    },
    popularKind() {
      return this.category.popular_sockets?.kind || null
    },
    eagerTiles() {
      if (this.variant === 'C') return 6
      return this.$device.isMobile ? 3 : 6
    },
    collectionItems() {
      return this.categories.map(child => ({
        name: child.name,
        url: this.$config.url + this.localePath(this.subcategoryRoute(child)),
      }))
    },
    tileLook() {
      return this.variant === 'C' ? 'row' : 'tile'
    },
    isAdmin() {
      return (
        this.$auth.loggedIn && this.$auth.user?.role?.identifier === 'admin'
      )
    },
  },
  methods: {
    socketRoute(socket) {
      if (socket.subcategory_slug) {
        return {
          name: 'categories-domain-category-subcategory',
          params: {
            domain: socket.domain_slug,
            category: socket.category_slug,
            subcategory: socket.subcategory_slug,
          },
        }
      }
      return {
        name: 'categories-domain-category',
        params: {
          domain: socket.domain_slug,
          category: socket.category_slug,
        },
      }
    },
  },
}
